import { Home, Library, User } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const linkBase =
  'flex min-h-[3.25rem] flex-1 flex-col items-center justify-center gap-0.5 border-t-2 border-t-transparent px-1 pt-0.5 text-[10px] font-medium transition sm:text-xs';

const linkActive = 'border-t-brand text-th-primary';
const linkInactive = 'text-th-tertiary';

export function MobileStoreBottomNav() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 border-t border-subtle bg-surface/95 pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-0.5 backdrop-blur-md md:hidden"
      aria-label="Store navigation"
    >
      <div className="mx-auto flex max-w-6xl">
        <NavLink
          to="/"
          end
          className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
        >
          <Home className="h-5 w-5 shrink-0" aria-hidden />
          <span>Home</span>
        </NavLink>
        <NavLink
          to="/library"
          className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
        >
          <Library className="h-5 w-5 shrink-0" aria-hidden />
          <span>Library</span>
        </NavLink>
        <NavLink
          to="/profile"
          className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
        >
          <User className="h-5 w-5 shrink-0" aria-hidden />
          <span>Profile</span>
        </NavLink>
      </div>
    </nav>
  );
}
